module.exports = __webpack_public_path__ + "img/create.9b422e53.png";